import React, { useMemo } from 'react';
import { FormGroup, Label, Card, CardBody, Input } from 'reactstrap';
import RubricTreemap, {
  TREEMAP_HEIGHT,
} from 'js/components/Charts/RubricTreemap';
import RubricScores from 'js/components/Charts/RubricScores';
import {
  filterEvaluationQuestionSetsForCurrentView,
  weightSchemeOptionValue,
  weightOverridesSortedForPicker,
} from 'js/utils/rubric';
import RubricPreviewTeamCombobox from './RubricPreviewTeamCombobox';

import styles from './RubricPreviews.module.scss';

function RubricPreviewsComponent({
  rubric,
  teamId,
  teams,
  onTeamIdChange,
  loading,
  loadError,
  scoresData,
  weightScheme,
  onWeightSchemeChange,
}) {
  const evaluation = scoresData?.evaluation;
  const questionSets = useMemo(
    () =>
      filterEvaluationQuestionSetsForCurrentView(
        evaluation?.question_sets,
        rubric?.document
      ),
    [evaluation?.question_sets, rubric?.document]
  );
  const weightOverrides = weightOverridesSortedForPicker(rubric?.document);

  return (
    <Card>
      <CardBody>
        <div className={styles.selectors}>
          <FormGroup>
            <Label for="rubric-preview-team-combobox">Team</Label>
            <RubricPreviewTeamCombobox
              id="rubric-preview-team-combobox"
              teams={teams}
              selectedId={teamId}
              onSelect={onTeamIdChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="rubric-preview-weight-scheme">Weight scheme</Label>
            <Input
              id="rubric-preview-weight-scheme"
              type="select"
              value={weightScheme}
              onChange={(ev) => onWeightSchemeChange(ev.target.value)}
              className="limited-width-lg"
            >
              <option value="">Default weights</option>
              {weightOverrides.map((override) => {
                const optVal = weightSchemeOptionValue(override);
                return (
                  <option key={optVal || 'scheme'} value={optVal}>
                    {override?.name || optVal || 'Scheme'}
                  </option>
                );
              })}
            </Input>
          </FormGroup>
        </div>
        {teamId == null || teamId === '' ? (
          <p className="text-muted mb-0">Select a team to view scores.</p>
        ) : (
          <>
            {loading && <p>Loading…</p>}
            {loadError && (
              <p className="text-danger">
                Unable to load rubric scores for this team.
              </p>
            )}
            {!loading && !loadError && scoresData && (
              <>
                <RubricTreemap
                  questionSets={questionSets}
                  height={TREEMAP_HEIGHT}
                />
                <RubricScores questionSets={questionSets} />
              </>
            )}
          </>
        )}
      </CardBody>
    </Card>
  );
}

export default RubricPreviewsComponent;
